import { Elm } from "../elm/src/Main.elm";
import { initialisePhoenixWebsockets } from "./socket";
import ActivityTour from "./activity-tour.js";
import ManualFeeTour from "./manual-fee-tour.js";
import Analytics from "./analytics.js";
import ScreenSize from "./screen-size.js";
import Editor from "./rich-text-editor.js";
import Common from "./common.js";

function run(el, inTimesheet) {
  const elmDiv = el;
  const animationsOn = window.animationsOn;
  const csrfToken = document.querySelector("meta[name='csrf-token']").content;
  const cspNonce = document.querySelector("meta[name='csp-nonce']").content;
  const region = Common.getRegionFromUrl();
  const newsUrl = "https://news.mitimes.com";
  const helpCentreUrl = "https://help.mitimes.com";

  if (elmDiv) {
    const app = Elm.Main.init({
      node: elmDiv,
      flags: {
        inTimesheet,
        animationsOn,
        csrfToken,
        cspNonce,
        region,
        newsUrl,
        helpCentreUrl,
      },
    });

    // ports (Elm interop)
    //
    // Setup Websockets
    app.ports.setUpWebsockets.subscribe(function (user) {
      initialisePhoenixWebsockets(app, user);
    });

    // Setup Analytics
    app.ports.setUpAnalytics.subscribe(function (user) {
      Analytics.init(window.amplitudeApiKey, user);
      Analytics.identify(user);
      Analytics.trackEvent("Opened Timesheet");
    });

    app.ports.selectActiveContent.subscribe(function () {
      document.activeElement.select();
    });

    app.ports.setValueOf.subscribe(function (args) {
      const elementId = args[0];
      const value = args[1];
      const element = document.getElementById(elementId);
      if (element) {
        element.value = value;
      }
    });

    app.ports.moveCaretToEnd.subscribe(function (elementId) {
      const element = document.getElementById(elementId);
      if (element && element.selectionStart === 0) {
        const len = element.value.length;
        element.setSelectionRange(len, len);
      }
    });

    app.ports.intoView.subscribe(function (params) {
      // Scrolling not needed on smaller screens and is causing issues
      if (window.innerWidth > 764) {
          window.requestAnimationFrame(function () {
            const element = document.getElementById(params.id);
            if (element) {
              element.scrollIntoView({
                behavior: "smooth",
                block: params.verticalAlignment,
              });
            }
          });
      };
    });

    app.ports.trackEventWithProperties.subscribe(function ({
      eventName: eventName,
      eventProperties: eventProperties,
    }) {
      Analytics.trackEvent(eventName, eventProperties);
    });

    /*** Tours ***/
    window.ManualFeeTour = ManualFeeTour; // expose so can run from console
    window.ActivityTour = ActivityTour; // expose so can run from console

    function completeTour(tourName) {
      app.ports.onCompleteTour.send("hasCompleted" + tourName);
    }

    // "Intro" Manual Fee tour
    //  - should not run in mobile because of hidden UI elements
    app.ports.startManualFeeTourPort.subscribe(function () {
      if (!ScreenSize.isMobile()) {
        const tour = ManualFeeTour.create();
        tour.start();
        tour.on("complete", (_) => completeTour("ManualFeeTour"));
        tour.on("cancel", (_) => completeTour("ManualFeeTour"));
      }
    });

    // Activity Review Tour
    // - triggered when user "Turns on Activities"
    // - fake activity created
    // - activities not tracked until this tour completes
    app.ports.startActivityReviewTourPort.subscribe(function () {
      const activityTour = ActivityTour.create();
      activityTour.start();
      activityTour.on("complete", (_) => completeTour("ActivityReviewTour"));
      activityTour.on("cancel", (_) => completeTour("ActivityReviewTour"));
    });

    function saveFileNote(data) {
      const fileNoteData = { content: data };

      app.ports.onRichTextContentChange.send(fileNoteData);
    }

    function openFileNote(data) {
      const fileNoteData = { content: data };

      app.ports.receiveFileNote.send(data);
    }

    function hasChangedContent() {
      app.ports.receiveConfirmTitleChanged.send({ titleChanged: true });
    }

    window.FileNote = {
      open: openFileNote,
    };

    app.ports.openFileNote.subscribe(function (fileNote) {
      Editor.openNote(fileNote, saveFileNote);
    });

    app.ports.updateContent.subscribe(function (fileNote) {
      Editor.updateContent(fileNote);
    });

    app.ports.cleanUp.subscribe(function () {
      Editor.destroy();
    });

    app.ports.focus.subscribe(function () {
      Editor.focus(hasChangedContent);
    });

    app.ports.setPageTitle.subscribe(function (title) {
      document.title = title;
    });

    app.ports.browserExtensionMessage.subscribe(function (message) {
      window.postMessage(message);
    });

    app.ports.openNewTab.subscribe(function (url) {
      window.open(url, '_blank');
    });
  }
}

export default { run };
